import React from 'react';

export const RuCountryModal = {
  title: 'Country',
  body: (
    <div>
      <p>
        The country where the tsunami effects were observed.
      </p>
    </div>
  ),
};
